module.exports = __webpack_public_path__ + "img/xqimg3.3b45cd5c.png";